import Select from 'components/Formik/Select';
import { useEffect } from 'react';

const ProductCategory = ({ initialValues, formik, data }) => {
	initialValues.productCategory = '';
	useEffect(() => {
		formik.values.Product_s_of_Interest__c = [];
		formik.values.Topics_Of_Interest__c = [];
	}, [formik.values.productCategory]);
	const { label, placeholder, options } = data;
	return (
		<Select
			label={label}
			name='productCategory'
			placeholder={placeholder}
			options={options}
		/>
	);
};

export default ProductCategory;
